import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useAssignRolePermission = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [assignRolePermissionLoading, setAssignRolePermissionLoading] =
    useState(false);

  const assignRolePermissionRequest = ({
    roleGuid,
    permissionGuid,
    onSuccess,
  }) => {
    setAssignRolePermissionLoading(true);
    axiosClient
      .put(`SettingAccount/Role/Permission/Assignment`, {
        roleGuid,
        permissionGuid,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`ویرایش دسترسی‌ها با موفقیت انجام شد`, {
            variant: 'success',
          });

          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setAssignRolePermissionLoading(false));
  };

  return { assignRolePermissionRequest, assignRolePermissionLoading };
};

export { useAssignRolePermission };
